module.exports = __webpack_public_path__ + "img/verify_suc.2ef99240.png";